import React from "react";
import { VisitDetails, MyDiary, MySR } from "@shared/components";
import { PageLayout } from "@features/shared";
import { usePageInitialization } from "@features/shared/hooks/usePageInitialization";

/**
 * ExceptionDealer Page
 * Displays market working details with visit information, diary, and SR reports
 */
const ExceptionDealerPage = () => {
  usePageInitialization();

  return (
    <PageLayout title="Market Working" backPath="/">
      <VisitDetails />
      <MyDiary />
      <MySR />
    </PageLayout>
  );
};

export default ExceptionDealerPage;
